import { mainPageAnimation } from './main-page.animation';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { merge, of, timer } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { BackgroundPlayerComponent, DwallClickableMediaDirective, HappyHoursService } from '@core';
import { ConfettiComponent } from '@app/components/confetti/confetti.component';
import { TabBarComponent } from '@app/components/tab-bar/tab-bar.component';
import { BigScreenSchedule } from '@app/service/big-screen-schedule.service';

@Component({
  selector: 'app-page-main',
  templateUrl: './main-page.component.html',
  styleUrls: ['./main-page.component.scss'],
  animations: [
    mainPageAnimation,
  ],
  imports: [
    ConfettiComponent,
    RouterOutlet,
    TabBarComponent,
    BackgroundPlayerComponent,
    DwallClickableMediaDirective,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainPageComponent {

  private readonly happyHoursService = inject(HappyHoursService);
  private readonly bigScreenSchedule = inject(BigScreenSchedule);

  public readonly showConfetti$ = this.happyHoursService.isNow$.pipe(
    switchMap((status) => {
      if (!status) {
        return of(false);
      }

      return merge(
        of(true),
        timer(4500).pipe(map(() => false)),
      );
    }),
  );

  public readonly showConfetti = toSignal(this.showConfetti$, {
    initialValue: false,
  });

  constructor() {
    this.bigScreenSchedule.initialize();
  }

}
